import { resolveText } from "../../i18n/resolve-text.js";
import { resolveLabel } from "../utils/resolve-label.js";
import { disableText, enableText } from "../../../i18n/text/captions.js";
import { createState } from "@videojs/store";
import { isCaptionOrSubtitleTrack } from "@videojs/utils/dom";
import { defaults } from "@videojs/utils/object";
//#region src/core/ui/captions-button/core.ts
var CaptionsButtonCore = class CaptionsButtonCore {
	static defaultProps = {
		label: "",
		disabled: false,
		menuTrigger: false
	};
	state = createState({
		subtitlesShowing: false,
		availability: "unavailable",
		disabled: true,
		hidden: true,
		label: ""
	});
	#props = { ...CaptionsButtonCore.defaultProps };
	#media = null;
	constructor(props) {
		if (props) this.setProps(props);
	}
	setProps(props) {
		this.#props = defaults(props, CaptionsButtonCore.defaultProps);
	}
	getLabel(state) {
		const label = resolveLabel(this.#props.label, state);
		if (label) return label;
		return state.subtitlesShowing ? disableText : enableText;
	}
	getAttrs(state) {
		return {
			"aria-label": this.getLabel(state),
			"aria-disabled": state.disabled ? "true" : void 0,
			hidden: state.hidden ? "" : void 0
		};
	}
	setMedia(media) {
		this.#media = media;
	}
	getState() {
		const media = this.#media;
		const availability = media.textTrackList.some(isCaptionOrSubtitleTrack) ? "available" : "unavailable";
		this.state.patch({
			subtitlesShowing: media.subtitlesShowing,
			availability,
			disabled: this.#props.disabled || availability !== "available",
			hidden: availability === "unavailable"
		});
		this.state.patch({ label: resolveText(this.getLabel(this.state.current)) });
		return this.state.current;
	}
	toggle(media) {
		this.setMedia(media);
		if (this.getState().disabled) return;
		if (this.#props.menuTrigger && getCaptionTrackCount(media) > 1) return;
		media.toggleSubtitles();
	}
};
function getCaptionTrackCount(media) {
	return media.textTrackList.filter(isCaptionOrSubtitleTrack).length;
}
//#endregion
export { CaptionsButtonCore };

//# sourceMappingURL=core.js.map